import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';

import SessionActions from '../../../actions/SessionActions';

class CancelConference extends Component{
  constructor() {
    super();
    this.state = {
      reason:''
    };
    this._handleInputChange = this._handleInputChange.bind(this);
    this._cancelConferencePopup = this._cancelConferencePopup.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired,
    _handleSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  _handleInputChange(event) {
    let value = event.target.value;
    this.setState({reason:value});
  };


 _cancelConferencePopup () {
    if(typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  render() {
    return(
      <Modal show={this.props.open} onHide={this._cancelConferencePopup}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title || 'Delete'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/*<h4 className="mt0">{this.props.message || 'Are you sure you want to cancel ?'} </h4>*/}
          <h4 className="mt0">Hi,</h4>
          <h4>Mentor has to cancel the conference because:</h4>

          <textarea className="form-control" rows="4" cols="50" placeholder="Please Enter The Reason...." onChange={this._handleInputChange.bind(this)} ></textarea>
          <h4>We apologize for any inconvenience this may have caused. </h4>
          <h5>Jeff Musk <br/> Contributor, <a href="https://mentorstudents.org/" target="_blank"> MentorStudents.org</a></h5>
          {/* <div>{this.state.reason}</div> */}
        </Modal.Body>
        <Modal.Footer>
              <Button disabled={!this.state.reason.length} title={this.state.reason.length ? '': 'Please enter the reason before cancel'} bsStyle="danger"
                      onClick={()=>{
                        this.props._handleSubmit(this.state.reason);
                        }} >
                Confrim
              </Button>
              {' '}
              <Button bsStyle="default"
                      onClick={this.props.onClose}>
                Cancel
              </Button>
        </Modal.Footer>
      </Modal>
    )
  };
}

export default CancelConference;
